module.exports = __webpack_public_path__ + "img/9fdd82f.png";